import { usePage } from "@inertiajs/react"

import type { Platform, SharedProps } from "@/types"

export function useVisiblePlatforms(platforms?: Platform[]): Platform[] {
  const { platforms: allPlatforms, platform_credentials } =
    usePage<SharedProps>().props
  const source = platforms ?? allPlatforms
  return source.filter(
    (platform) =>
      !platform.requires_credential ||
      platform_credentials.some(
        (credential) => credential.platform_name === platform.name,
      ),
  )
}
